import { CommentDto, ModuleRegistrationDto, ModuleRegistrationInfoDto } from '@mse-reg/clients';

export const addCommentToRegistrationInfo = (registrations: ModuleRegistrationInfoDto[], comment: CommentDto) => {
  return registrations.map((r) =>
    r.id === comment.registrationId
      ? {
          ...r,
          internalComment: comment.isInternal ? comment.comment : r.internalComment,
          comment: !comment.isInternal ? comment.comment : r.comment,
          comments: [...(r.comments ?? []), comment],
        }
      : r,
  );
};

export const addCommentToRegistration = (registrations: ModuleRegistrationDto[], comment: CommentDto) => {
  return registrations.map((r) =>
    r.id === comment.registrationId
      ? {
          ...r,
          internalComment: comment.isInternal ? comment.comment : r.internalComment,
          comment: !comment.isInternal ? comment.comment : r.comment,
          comments: [...(r.comments ?? []), comment],
        }
      : r,
  );
};

export const removeCommentFromRegistrationInfo = (registrations: ModuleRegistrationInfoDto[], comment: CommentDto) => {
  return registrations.map((r) =>
    r.id === comment.registrationId
      ? {
          ...r,
          comments:
            r.comments
              ?.filter((c) => c.id !== comment.id)
              .map((c) => (c.answerToId === comment.id ? { ...c, answerToId: undefined } : c)) ?? [],
        }
      : r,
  );
};

export const removeCommentFromRegistration = (registrations: ModuleRegistrationDto[], comment: CommentDto) => {
  return registrations.map((r) =>
    r.id === comment.registrationId
      ? {
          ...r,
          comments:
            r.comments
              ?.filter((c) => c.id !== comment.id)
              .map((c) => (c.answerToId === comment.id ? { ...c, answerToId: undefined } : c)) ?? [],
        }
      : r,
  );
};
